import React from 'react';

const Stats = () => {
  return (
    <div className="stats">
      <div className="stat-card">
        <div className="stat-number">16</div>
        <div className="stat-label">Общо дружества</div>
      </div>
      <div className="stat-card">
        <div className="stat-number">3+</div>
        <div className="stat-label">Години стаж</div>
      </div>
    </div>
  );
};

export default Stats;